<template>
  <div class="summary-sm shadow" :class="{ 'active': expandSummary }">
    <div class="order block" :class="{ 'order--active': expandSummary, 'order--inactive': !expandSummary }" @click="expandSummary = !expandSummary">
      <i class="order__icon icon-cart"></i>
      <span class="order__label">รายการที่เลือกไว้
        <span class="order__icon icon-arrow-down" v-show="!expandSummary"></span>
        <span class="order__icon icon-arrow-up" v-show="expandSummary"></span>
      </span>
      <span class="order__label order__label--value fl-right">
        {{ $utils.getCartGrandTotalPrice() | comma }}
        <span class="order__label order__label--unit">บาท</span>
      </span>
    </div>

    <transition name="slide-down">
      <div class="slide-down-wrapper" v-show="expandSummary">
        <div class="block-primary block slide-down-item">
          <cart-summary></cart-summary>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import CartSummary from './CartSummary.vue'

export default {
  components: {
    CartSummary
  },
  name: 'PaymentSummary',
  data () {
    return {
      expandSummary: false
    }
  },
  computed: {
    shippingFee () {
      const normalFee = this.$store.state.cart.reduce((a, b) => {
        if (b.product.shippingGroup) {
          return a
        }
        const shippingFee = this.$utils.shippingFee(b.product, b.quantity)
        return a + shippingFee
      }, 0)

      return normalFee + Object.keys(this.shippingGroups).reduce((a, b) => {
        return a + this.shippingGroupFee(b)
      }, 0)
    },
    shippingGroups () {
      let groups = {}
      for (let item of this.$store.state.cart) {
        if (item.product.shippingGroup) {
          const group = item.product.shippingGroup
          groups[group] = groups[group] || []
          groups[group].push(item)
        }
      }
      return groups
    }
  },
  methods: {
    shippingGroupFee (group) {
      const items = this.shippingGroups[group]
      if (!items || !items.length) {
        return 0
      }

      if (group.match(/weight:/)) {
        const sampleProduct = items[0].product
        const mockProduct = {
          shippable: true,
          shippingRules: sampleProduct.shippingRules,
          shippingGroup: group,
          attributes: {
            weight: 0
          }
        }
        mockProduct.attributes.weight = items.reduce((a, b) => {
          return a + (b.product.attributes.weight * b.quantity)
        }, 0)
        return this.$utils.shippingFee(mockProduct, 1)
      }

      const sampleProduct = items[0].product
      const quantity = items.reduce((a, b) => {
        return a + b.quantity
      }, 0)
      return this.$utils.shippingFee(sampleProduct, quantity)
    }
  }
}
</script>

<style scoped lang="scss">
.summary.active {
  /*margin: 0;*/
}
.order {
  transition-property: background-color;
  transition-duration: .15s;
}
</style>



// WEBPACK FOOTER //
// PaymentSummary.vue?1455b7c1